module.exports = __webpack_public_path__ + "img/351acd125f46805aca8bc8f7d1e9ba60.47b05332.jpg";